<template>
  <div class="children-table__row">
    <div class="children-table__row-col col-name">{{ childName }}</div>
    <div class="children-table__row-col col-height">
      <v-text-field
        v-model.number="localHeight"
        @update:modelValue="emitHeight"
        density="compact"
        hide-details
        variant="outlined"
        type="number"
        suffix="cm"
      />
    </div>
    <div class="children-table__row-col col-weight">
      <v-text-field
        v-model.number="localWeight"
        @update:modelValue="emitWeight"
        density="compact"
        hide-details
        variant="outlined"
        type="number"
        suffix="kg"
      />
    </div>
    <div class="children-table__row-col col-other">
      <v-text-field
        v-model="localRemarks"
        @update:modelValue="emitRemarks"
        density="compact"
        hide-details
        variant="outlined"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { NurseryGrowthDetailResponse } from 'chaild-api/lib';

export default defineComponent({
  props: {
    record: {
      type: Object as PropType<NurseryGrowthDetailResponse>,
      required: true,
    }
  },

  // ⭕️ 修正3: 入力途中の文字が消えたり戻ったりしないよう、自分の手元にデータをコピーして持つ
  data() {
    return {
      localHeight: null as number | null,
      localWeight: null as number | null,
      localRemarks: null as string | null,
    };
  },

  // ⭕️ 修正4: 親からデータ（record）が降ってきたら、手元のデータを更新する
  watch: {
    record: {
      immediate: true,
      handler(newVal: NurseryGrowthDetailResponse) {
        const growthRecord = (newVal.records && newVal.records.length > 0) ? newVal.records[0] : null;
        this.localHeight = growthRecord ? growthRecord.height : null;
        this.localWeight = growthRecord ? growthRecord.weight : null;
        this.localRemarks = growthRecord ? growthRecord.remarks : null;
      }
    }
  },

  computed: {
    childName(): string {
      return `${this.record.child.lastName} ${this.record.child.firstName}`;
    },
  },

  // ⭕️ 修正5: 入力があったら、手元のデータを親に教えてあげる ($emit)
  methods: {
    emitHeight() {
      this.$emit('inputHeight', this.localHeight);
    },
    emitWeight() {
      this.$emit('inputWeight', this.localWeight);
    },
    emitRemarks() {
      this.$emit('inputRemarks', this.localRemarks);
    },
  },
});
</script>

<style lang="scss" scoped>
/* スタイルは親コンポーネントで定義されているため空でOK */
</style>